// Daily rotating beauty tips (replaces affirmations on the dashboard).
export const BEAUTY_TIPS = [
  "Apply SPF 50 every single morning — sun exposure is the #1 cause of hyperpigmentation and premature aging.",
  "Pat — never rub — your skin dry. Friction triggers post-inflammatory pigmentation, especially on melanin-rich skin.",
  "Layer your skincare from thinnest to thickest texture: toner → serum → moisturizer → SPF.",
  "Niacinamide at 5% is the gentlest brightener for sensitive and melanin-rich skin tones.",
  "Hyaluronic acid needs moisture to work — always apply to damp skin, then seal with moisturizer.",
  "Detangle curly, coily and kinky hair on DAMP hair with conditioner — never dry. It cuts breakage by 80%.",
  "Sleep on satin or silk every night. Cotton steals moisture from skin and hair.",
  "Massage your scalp for 5 minutes daily to boost circulation and accelerate hair growth.",
  "The LOC method (Liquid, Oil, Cream) locks moisture into 4C hair for up to 3 days.",
  "Less is more — use only 3 active ingredients max per routine to avoid barrier damage.",
  "Retinol at night, vitamin C in the morning. They work in opposite ways and shouldn't be mixed.",
  "Drink at least 2 litres of water daily — hydration shows on your skin within 7 days.",
  "Always patch test new products on your inner forearm for 48 hours before applying to your face.",
  "Your skin barrier rebuilds while you sleep — never skip your PM routine, even when tired.",
  "Vitamin C oxidizes when exposed to air — keep it in dark glass and use within 3 months.",
  "Trim your hair every 8-12 weeks to prevent split ends from traveling up the strand.",
  "Eat a rainbow daily — colourful fruits and vegetables feed your skin with antioxidants.",
  "Your gut and skin are connected — fix breakouts by reducing dairy and refined sugar first.",
  "Apply skincare in upward motions — gravity already pulls everything down.",
  "Cool water in your final rinse seals the hair cuticle and adds shine.",
];

export function pickDaily(arr) {
  // Stable daily index so all users see the same tip on the same day.
  const day = Math.floor(new Date().setHours(0, 0, 0, 0) / 86400000);
  return arr[day % arr.length];
}
